import type { DeliveryMethod, ManualApprovalStatus, OrderStatus } from '../types/order';

export interface ManualApprovalReadable {
  readonly delivery_method?: DeliveryMethod;
  readonly status: OrderStatus;
  readonly manual_approval_status?: ManualApprovalStatus | null;
}

export function isManualApprovalPending(order: ManualApprovalReadable): boolean {
  return order.manual_approval_status === 'pending';
}

export function manualApprovalBlocksFulfillment(order: ManualApprovalReadable): boolean {
  return order.status === 'ordered' && isManualApprovalPending(order);
}

export function isFulfillmentReadyOrderedOrder(order: ManualApprovalReadable): boolean {
  if (order.status !== 'ordered') return false;
  const reviewStatus = order.manual_approval_status ?? 'not_required';
  return reviewStatus === 'not_required' || reviewStatus === 'approved';
}

export function isCourierAssignableOrder(order: ManualApprovalReadable): boolean {
  return (
    (order.delivery_method === 'address' || order.delivery_method === 'location') &&
    (order.status === 'shipped' || isFulfillmentReadyOrderedOrder(order))
  );
}
